import React, { useState } from "react";
import ModalComponent from "../../common/components/modal/modalComponent";
import { Button } from "./ui/button";
import { loadImage } from "../../common/services/uiService";

const UnsavedChangesModal = ({
  show,
  onHide,
  onLeftAction,
  onRightAction,
  message = "You have unsaved changes. Are you sure you want to discard them?",
  leftLabel = "Save",
  rightLabel = "Discard",
}) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const loadingIcon = loadImage("loading_continuous.gif");

  const handleLeftAction = async () => {
    if (!onLeftAction) {
      onHide();
      return;
    }

    setIsProcessing(true);
    try {
      await onLeftAction();
      onHide();
    } catch (error) {
      console.error("Failed to execute left action:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleRightAction = () => {
    if (onRightAction) {
      onRightAction();
    }
    onHide();
  };

  const handleHide = () => {
    if (!isProcessing) {
      onHide();
    }
  };

  return (
    <>
      <style>
        {`
        .modal-wrap .btn:hover {
          margin: 9px !important;
        }
        
        .modal-wrap .modal-body-wrap {
          justify-content: flex-start !important;
        }
      `}
      </style>
      <ModalComponent
        show={show}
        onHide={handleHide}
        bodyContent={
          <div style={{ textAlign: "left" }}>
            <p>{message}</p>
          </div>
        }
        footerContent={
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            {onLeftAction && (
              <Button onClick={handleLeftAction} disabled={isProcessing}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minWidth: "60px",
                  }}
                >
                  {isProcessing ? (
                    <img
                      src={loadingIcon}
                      alt="loading"
                      style={{
                        height: "20px",
                        width: "20px",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    leftLabel
                  )}
                </div>
              </Button>
            )}

            {onRightAction && (
              <Button onClick={handleRightAction} disabled={isProcessing}>
                {rightLabel}
              </Button>
            )}
          </div>
        }
      />
    </>
  );
};

export default UnsavedChangesModal;
